import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createApp } from 'vue'
import App from './App.vue'
import router, { loadThemeRoutes } from './router'

// 抑制浏览器 ResizeObserver 良性警告（全局 + Vue 级别双保险）
const ignoreResizeObserverError = (e) => {
  const msg = e?.message || (typeof e === 'string' ? e : '')
  if (msg.includes('ResizeObserver loop')) {
    e?.stopImmediatePropagation?.()
    e?.preventDefault?.()
    return true
  }
  return false
}
window.addEventListener('error', (e) => {
  if (ignoreResizeObserverError(e)) return
  // 也忽略 e.message 不同但 e 本身是指向该错误的引用
  try { if (e?.message?.includes?.('ResizeObserver')) { e.stopImmediatePropagation(); e.preventDefault() } } catch(_) {}
})
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/css/common.css'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })

// 全局抑制 ResizeObserver 良性警告（el-table 渲染时浏览器触发，非代码错误）
if (window.ResizeObserver) {
  const RO = window.ResizeObserver
  window.ResizeObserver = class extends RO {
    constructor(callback) {
      super((entries, observer) => {
        try { callback(entries, observer) } catch (e) {
          if (!String(e).includes('ResizeObserver')) throw e
        }
      })
    }
  }
}
const ignoreRO = e => { const m = e?.message || e?.reason || String(e); return m.includes('ResizeObserver') }
app.config.errorHandler = err => { if (!ignoreRO(err)) console.error(err) }
app.config.warnHandler = msg => { if (!ignoreRO(msg)) console.warn(msg) }
window.onerror = msg => ignoreRO(msg) ? true : undefined
window.addEventListener('error', e => ignoreRO(e) && e.preventDefault())
window.addEventListener('unhandledrejection', e => ignoreRO(e) && e.preventDefault())

// 预加载主题路由（阻塞，确保路由加载完成后再挂载应用）
console.log('[Main] Pre-loading theme routes...')
loadThemeRoutes().then(() => {
  console.log('[Main] Theme routes loaded')
  console.log('[Main] Current routes:', router.getRoutes().map(r => ({ path: r.path, name: r.name })))
  
  // 挂载应用
  app.mount('#app')
  
  // 强制触发一次路由匹配
  const currentHash = window.location.hash.slice(1) || '/'
  console.log('[Main] Current hash path:', currentHash)
  router.replace(currentHash).catch(err => {
    console.warn('[Main] Route replace failed:', err)
  })
}).catch(error => {
  console.warn('[Main] Failed to pre-load theme routes:', error)
  app.mount('#app')
})
